import { useEffect } from 'react';
import { Col, Container, Jumbotron, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { getPublicados } from '../../appStore/convocatoria';
import bg from '../../img/new-background.jpg';
import { Concursos } from './Concursos';

const Home = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPublicados());
    document.title = 'Concursar - Página Principal';
  }, [dispatch]);

  return (
    <>
      <Jumbotron className="jumbotron-poncho text-white" style={{ backgroundColor: '#232D4F' }}>
        <div className="overlay"></div>
        <Container fluid className="jumbotron_bar">
          <Row>
            <Col>
              <Container>
                <ol className="breadcrumb">
                  <li>Ministerio de Desregulación y Transformación del Estado</li>
                </ol>
              </Container>
            </Col>
          </Row>
        </Container>
        <Container className="jumbotron_body">
          <Row>
            <Col className="text-center">
              <h1 className="font-lora">CONCURSAR</h1>
              <p> Secretaría de Transformación del Estado y Función Pública</p>
            </Col>
          </Row>
        </Container>
      </Jumbotron>
      <Container>
        <Concursos />
      </Container>
    </>
  );
};

export default Home;
